import r from"react";var t=r.createContext({});export{t as MoreFilterContext};
